module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.services.length) ? _c('div', {
    class: [_vm.tag, (_vm.tag + "-" + _vm.position)]
  }, [_c('ul', _vm._l((_vm.services), function(service, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "rel": "noopener",
        "href": service.url(_vm.url, _vm.title),
        "title": _vm.firstLetterCapital(service.icon)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.popup(service.url(_vm.url, _vm.title), '', _vm.popupWidth, _vm.popupHeight)
        }
      }
    }, [_c('i', {
      class: ['mdi', ("mdi-" + (service.icon))],
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "//cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/2.0.46/css/materialdesignicons.min.css"
    }
  }), _vm._v(" "), _c('vc-style', [_vm._v("\n    .vc-social-bar\n    {\n      z-index: " + _vm._s(_vm.zIndex) + ";\n      background: " + _vm._s(_vm.bgColor) + ";\n      box-shadow: " + _vm._s(_vm.shadow) + ";\n      backdrop-filter: blur(" + _vm._s(_vm.backdropBlur) + "px);\n    }\n\n    .vc-social-bar .mdi {\n      font-size: " + _vm._s(_vm.fontSize) + "em;\n    }\n\n    .vc-social-bar a,\n    .vc-social-bar .mdi {\n      color: " + _vm._s(_vm.color) + ";\n    }\n  ")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-418126af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vc-social-bar.vue
// module id = 18
// module chunks = 1